import React, {Component} from 'react'
import {toJS} from 'mobx'
import {inject, observer} from 'mobx-react'
import { Modal, Form, Row, Col, Input, Select, Radio, Checkbox, Button, Typography, Divider, Spin, Descriptions, Tooltip } from 'antd'
import {withTranslation} from 'react-i18next'
import { HistoryOutlined } from '@ant-design/icons'
import { CTIPlus } from 'cti-js-sdk'
import callForwarded from '../../../assets/images/call-forwarded.png'
import callMuted from '../../../assets/images/call-muted.png'
import deleteIcon from '../../../assets/images/del.png'
import alertMessage from '../../../utils/alertMessage'
const storage = window.localStorage
const { Text } = Typography;

@inject('accountStore', 'manualOutboundCallStore')
@observer
class FormModal extends Component {
  state = {
    taskId: null,
    visitorPhone: '',
    questionContent: [],
    questionNameValue: '',
    canCall: false,
    canEnd: false,
    canSave: false,
    isCallEnd: false,
    canCancel: true,
    callDuration: 0,  // 通话时长（秒）
    timer: null,      // 计时器
    telDisabled: false,
  }

  formRef = React.createRef()
  phoneInputRef = React.createRef()
  seatData = {}  // 坐席信息
  cti = null  // CTI 实例
  ctiAllHandler = null
  ctiAgentHandler = null
  historyDebounceTimer = null  // 历史问卷请求防抖定时器

  componentDidMount() {
    var _this = this
    const {accountStore, manualOutboundCallStore, phoneObj} = _this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))

    // 并行执行三个请求，全部完成后设置 isFetchingToken = false
    manualOutboundCallStore.initAllData({
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
    }).then(() => {
      if (phoneObj) {
        _this.formRef.current.setFieldsValue({
          marketGroupId: phoneObj?.marketingGroupId?.[0],
          visitorPhone: _this.maskPhone(phoneObj?.['手机号码']),
        })
        _this.setState({
          visitorPhone: phoneObj?.['手机号码'],
          canCall: true,
          telDisabled: true,
        })
        manualOutboundCallStore.onGetHistoryAction({
          "configName": "",
          "endTime": "",
          "isPowerUser": true,
          "logUser": "",
          "marketGroupId": "",
          "page": 0,
          "size": 0,
          "startTime": "",
          "visitorPhone": phoneObj?.['手机号码']
        })
      }
    })
  }

  componentWillUnmount() {
    // 组件卸载时清除计时器
    this.stopTimer()
    if (this.historyDebounceTimer) {
      clearTimeout(this.historyDebounceTimer)
    }
  }

  handleOk = (isClose, visitorPhone) => {
    const {manualOutboundCallStore, phoneObj, title, accountStore} = this.props
    const {taskId, questionContent, isCallEnd} = this.state
    const infos = JSON.parse(storage.getItem('accountInfos'))
    const email = accountStore?.accountInfos?.data?.name || infos?.data?.name
    let _this = this.cti
    return this.formRef.current.validateFields().then(fieldsValue => {
      this.setState({ callDuration: 0, canCancel: false, telDisabled: true })
      let params = {
        "marketGroupId": fieldsValue?.marketGroupId,
        "visitorPhone": phoneObj ? phoneObj?.['手机号码'] : fieldsValue?.visitorPhone,
        "remark": isCallEnd ? questionContent : null,
      }
      if (taskId) {
        return manualOutboundCallStore.onAddJobAction({...params, id: taskId}, title, isClose).then(res=> {
          if (res?.data?.code === 0) {
            this.handleCancel()
          }
        })
      } else {
        return manualOutboundCallStore.onAddJobAction({...params}, null, isClose).then(res=> {
          if (res?.data?.code === 0) {
            const newTaskId = res?.data?.data
            this.setState({taskId: newTaskId}, () => {
              if(isClose){
                if (_this && _this.Agent) {
                  // _this.Agent.login({
                  //   bindTel: '8001',
                  // })
                  const callOutResult = _this.Agent.callOut({
                    tel: visitorPhone,
                    agPho: '8001',
                    userData: JSON.stringify({
                      id: newTaskId,
                      email
                    }),
                  }, (data) => {
                    if (data?.code === 0) {
                      this.setState({canEnd: true, canSave: false})
                      // 启动计时器
                      this.startTimer()
                    } else {
                      alertMessage.error(data?.message || 'Call Failed！')
                      this.setState({ canCancel: true })
                      manualOutboundCallStore.onAddJobAction({...params, id: newTaskId, notConnectedReason: data?.message || null}, title, isClose)
                    }
                  })
                  // callOut 可能不返回 Promise，需要安全检查
                  if (callOutResult && typeof callOutResult.catch === 'function') {
                    callOutResult.catch(err => {
                      console.log(err)
                      // callOut 异常时恢复可取消状态，避免用户卡死无法关闭弹窗
                      alertMessage.error('Call Failed！')
                      this.setState({ canCancel: true })
                    })
                  }
                }
              } else {
                this.handleCancel()
              }
            })
          }
        })
      }
    }).catch(() => {})
  }
  // 监听手机号变化，获取历史问卷
  onChangeVisitorPhone = (e) => {
    const { manualOutboundCallStore } = this.props
    const regPhone = /^1[3-9]\d{9}$|^\d{2}\*{7}\d{2}$/
    const phoneValue = e.target.value
    this.setState({visitorPhone: phoneValue})

    // 验证手机号格式，只有验证通过才设置 canCall 为 true
    const isPhoneValid = regPhone.test(phoneValue)
    this.setState({canCall: isPhoneValid})

    // 防抖：避免每次按键都触发 API 请求
    if (this.historyDebounceTimer) {
      clearTimeout(this.historyDebounceTimer)
    }
    if(phoneValue) {
      this.historyDebounceTimer = setTimeout(() => {
        manualOutboundCallStore.onGetHistoryAction({
          "visitorPhone": phoneValue
        })
      }, 500)
    } else {
      manualOutboundCallStore.onChangeHistoryList([])
    }
  }

  // 获取Token
  getSeatToken = async (params) => {
    const { manualOutboundCallStore } = this.props
    const res = await manualOutboundCallStore.onGetTokenAction(params);
    if (res?.data?.code === 0) {
      const { token, ...restData } = res.data.data;
      this.seatData = restData;

      // 初始化 CTI 并保存实例
      var _this = this
      const ctiToken = manualOutboundCallStore.ctiToken
      if (ctiToken) {
        _this.cti = new CTIPlus({
          token: `Bearer ${ctiToken}`,
          agentPhone: '8001', //sip 电话
          agNo: '1001',
          initWithLogin: true,
          autoForceLogin: true,
          check: true,
          websocket: true,
          renderHtml: {}
        })
        _this.cti.init(() => {
          console.log('CTI initialized')
        });

        if (!params?.username) {
          // 监听所有事件
          this.ctiAllHandler = _this.cti.Event.add('all', (data) => {
            console.log('event', data)
          })
          // 监听 agentUnbusy 事件，当坐席状态变为空闲时自动挂断电话
          this.ctiAgentHandler = _this.cti.Event.add('agentUnbusy', (data) => {
            console.log('agentUnbusy event', data)
            if (_this.state.visitorPhone ? true : _this.state.canCall) {
              _this.handleCallEnd()
            }
          })
        }
      }
    }
    return this.seatData;
  }

  // 拨打电话
  handleCallClick = (isCall) => {
    return this.formRef.current.validateFields().then(async (fieldsValue) => {
      // 立即禁用取消按钮，防止拨号阶段用户关闭弹窗导致状态不一致
      this.setState({ canCancel: false })
      await this.getSeatToken({});

      // CTI 初始化失败时恢复可取消状态，避免用户卡死
      if (!this.cti) {
        this.setState({ canCancel: true })
        return
      }

      const {visitorPhone} = this.state
      if (visitorPhone) {
        // 重置计时器
        this.stopTimer()
        // 执行 handleOk，在获取到 taskId 后执行 Agent 相关事件
        setTimeout(() => {
          this.handleOk(true, visitorPhone)
        }, 2000);
      }
    }).catch(() => {})
  }

  // 启动计时器
  startTimer = () => {
    const timer = setInterval(() => {
      this.setState((prevState) => ({
        callDuration: prevState.callDuration + 1
      }))
    }, 1000)
    this.setState({ timer })
  }

  // 停止计时器
  stopTimer = () => {
    if (this.state.timer) {
      clearInterval(this.state.timer)
      this.setState({ timer: null })
    }
  }

  // 格式化时间显示
  formatDuration = (seconds) => {
    const mins = Math.floor(seconds / 60)
    const secs = seconds % 60
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`
  }
  // 席位登出（清理本地数据 + 移除 CTI 事件监听）
  seatLogout = () => {
    var _this = this
    this.seatData = {}

    if(this.ctiAllHandler && _this.cti && _this.cti.Event){
      _this.cti.Event.remove(this.ctiAllHandler);
      this.ctiAllHandler = null;
    }
    if(this.ctiAgentHandler && _this.cti && _this.cti.Event){
      _this.cti.Event.remove(this.ctiAgentHandler);
      this.ctiAgentHandler = null;
    }
  }
  // 挂断电话
  handleCallEnd = () => {
    this.setState({canEnd: false, canSave: true, canCall: false, isCallEnd: true})
    this.stopTimer()
    if (this.cti && this.cti.Session) {
      this.cti.Session.hangup()
    }
  }
  // 点击数字按钮拨号
  handleNumberClick = (num) => {
    const {visitorPhone} = this.state
    const inputElement = this.phoneInputRef.current?.input
    let newPhoneNumber = ''
    if (inputElement) {
      const selectionStart = inputElement.selectionStart
      const selectionEnd = inputElement.selectionEnd
      if (selectionStart !== undefined && selectionEnd !== undefined) {
        const before = visitorPhone.substring(0, selectionStart)
        const after = visitorPhone.substring(selectionEnd)
        newPhoneNumber = before + num + after
        this.setState({visitorPhone: newPhoneNumber}, () => {
          if (this.formRef.current) {
            this.formRef.current.setFieldsValue({visitorPhone: newPhoneNumber})
            this.formRef.current.validateFields(['visitorPhone'])
          }
          const newPos = selectionStart + 1
          inputElement.setSelectionRange(newPos, newPos)
          inputElement.focus()
          const event = { target: { value: newPhoneNumber } }
          this.onChangeVisitorPhone(event)
        })
      }
    }
  }
  // 删除光标前的字符
  handleBackspaceClick = () => {
    const {visitorPhone} = this.state
    const inputElement = this.phoneInputRef.current?.input
    if (inputElement && visitorPhone) {
      const selectionStart = inputElement.selectionStart
      if (selectionStart !== undefined && selectionStart > 0) {
        const before = visitorPhone.substring(0, selectionStart - 1)
        const after = visitorPhone.substring(selectionStart)
        const newPhoneNumber = before + after
        // 删除光标前的字符，光标位置减 1
        const newPos = selectionStart - 1

        // 先手动更新 input 的 value，避免 React 重新渲染导致光标重置
        inputElement.value = newPhoneNumber
        inputElement.focus()
        inputElement.setSelectionRange(newPos, newPos)

        // 然后更新 React state
        this.setState({visitorPhone: newPhoneNumber})

        // 更新表单验证
        if (this.formRef.current) {
          this.formRef.current.setFieldsValue({visitorPhone: newPhoneNumber})
          this.formRef.current.validateFields(['visitorPhone'])
        }

        // 触发 onChange 回调
        const event = { target: { value: newPhoneNumber } }
        this.onChangeVisitorPhone(event)
      }
    }
  }
  // 监听备注模板变化
  onChangeRemarkTemplate = (value) => {
    const { manualOutboundCallStore } = this.props
    if (!value) {
      this.setState({
        questionNameValue: '',
        questionContent: []
      })
      return
    }
    manualOutboundCallStore.onGetRemarkTemplateAction(value).then(res=> {
      if (res) {
        this.setState({
          questionNameValue: value,
          questionContent: res?.questionContent || []
        })
      }
    })
  }
  // 监听问卷内容变化
  onChangeQuestionContent = (e, index) => {
    const {questionContent} = this.state
    const newList = [...questionContent]
    newList[index].data = e
    this.setState({
      questionContent: e ? newList : []
    })
  }
  maskPhone = (phone) => {
    if (!phone || phone.length !== 11) return phone;
    return phone.slice(0, 2) + '*'.repeat(7) + phone.slice(-2);
  }
  handleCancel = () => {
    const { manualOutboundCallStore,handleCancel } = this.props
    if(this.cti && this.cti.Agent){
      this.cti.Agent.logout();
    }
    this.seatLogout();
    this.setState({canEnd: false, canSave: false, canCall: false, isCallEnd: false, canCancel: true})
    handleCancel()
    manualOutboundCallStore.onChangeHistoryList([])
  }
  render() {
    const { manualOutboundCallStore, addModalVisible, phoneObj, title, t } = this.props
    const { groupList, remarkTemplateList, isFetchingRemarkTemplate, historyList } = manualOutboundCallStore
    const { visitorPhone, questionContent, questionNameValue } = this.state

    const regPhone = /^1[3-9]\d{9}$|^\d{2}\*{7}\d{2}$/
    const numberButtonStyle = {
      marginLeft: '14px',
      marginTop: '7px',
      marginBottom: '7px',
      width: '40px',
      height: '40px',
      fontSize: '16px',
      background: '#f0f0f0',
      border: 'none',
      borderRadius: '10px'
    }
    const newGroupList = phoneObj?.marketingGroupId?.length > 0 ? groupList.filter(item => phoneObj?.marketingGroupId?.includes(item.id)) : groupList

    return (
      <>
        <Modal
          title={title === 'edit' ? t(`general.edit`) + t(`menu.manualCallManagement`) : t(`general.addData`) + t(`menu.manualCallManagement`)}
          closable={this.state.canCancel}
          visible={addModalVisible}
          onCancel={this.handleCancel}
          maskClosable={false}
          destroyOnClose={true}
          width={'46%'}
          centered
          footer={[
            <Button key="Save" type="primary" onClick={()=> this.handleOk(false)} disabled={!this.state.canSave}>{t(`general.save`)}</Button>,
            <Button key="Cancel" onClick={this.handleCancel} disabled={!this.state.canCancel}>{t(`general.cancel`)}</Button>,
          ]}
        >
          <div className='PHONE_BAR'>
            <div id="PHONE_BAR"></div>
          </div>
          <Form ref={this.formRef} key="addMapping" layout="vertical">
            <Row gutter={[50, 16]}>
              <Col flex="auto"><div style={{borderRight: '1px solid #e8e8e8', paddingRight: 20}}>
                <Form.Item name="marketGroupId" label={t(`outboundCall.groupName`)}
                  rules={[{ required: true, message: t(`general.pleaseSelect`) }]}
                >
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } disabled={this.state.telDisabled}>
                    {newGroupList.map(item => (
                      <Select.Option key={item.id} value={item.id}>{item.groupName}</Select.Option>
                    ))}
                  </Select>
                </Form.Item>
                <Row>
                  <Col flex="auto">
                    <Form.Item name="visitorPhone" label={t(`outboundCall.callNumber`)}
                      rules={[{
                        required: true,
                        message: t(`general.pleaseEnter`) + '11位手机号',
                        pattern: regPhone,
                      }]}
                    >
                      <Input
                        ref={this.phoneInputRef}
                        placeholder={t(`general.pleaseEnter`)}
                        value={visitorPhone}
                        onChange={(e) => this.onChangeVisitorPhone(e)}
                        allowClear
                        disabled={phoneObj?.['手机号码'] || this.state.telDisabled}
                      />
                    </Form.Item>
                  </Col>
                  <Col flex="100px" style={{marginTop: 30, textAlign: 'right', padding: 0}}>
                    {(visitorPhone && !this.state.telDisabled) && <Button
                      type="link"
                      style={{ padding: 0, margin: '0 15px 0 0'}}
                      onClick={() => this.handleBackspaceClick()}
                    ><img src={deleteIcon} alt="" style={{width: '24px', height: 'auto', left: 0}} /></Button>}
                    <Button
                      type="primary"
                      style={{ background: '#61c454', borderColor: '#61c454', height: '32px', width: '32px', borderRadius: 4}}
                      onClick={() => this.handleCallClick()}
                      disabled={!this.state.canCall}
                    ><img src={callForwarded} alt="" /></Button>
                  </Col>
                </Row>
                <Form.Item name="remarkTemplate" label={t(`outboundCall.remarkTemplate`)}>
                  <Select placeholder={t(`general.pleaseSelect`)} allowClear showSearch filterOption={(input, option) =>
                    option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                  } onChange={(value) => this.onChangeRemarkTemplate(value)}>
                    {remarkTemplateList?.map(item => (<Select.Option key={item.id} value={item.id}>{item.questionName}</Select.Option>))}
                  </Select>
                </Form.Item>
              </div></Col>
              <Col flex="260px">
              {this.state.canEnd ? <div className='call-ing'>
                <div className='call-ing-content'>
                  <span style={{color: '#61c454'}}>{t(`outboundCall.calling`)}</span>
                  <span>{this.formatDuration(this.state.callDuration)}</span>
                </div>
                <Button
                  type="danger"
                  icon={<img src={callMuted} alt="" />}
                  className='call-btn'
                  style={{ background: '#ed6a5e', borderColor: '#ed6a5e' }}
                  onClick={() => this.handleCallEnd()}
                />
              </div> : <div>
                  {[1, 2, 3, 4, 5, 6, 7, 8, 9, '*', 0, '#'].map(num => (
                    <Button
                      key={num}
                      style={numberButtonStyle}
                      onClick={() => this.handleNumberClick(num)}
                      disabled={this.state.telDisabled}
                    >
                      {num}
                    </Button>
                  ))}
                </div>}
              </Col>
            </Row>
            {questionNameValue && <>
              <Divider />
              <Row gutter={[16, 0]}>
                <Col span={24}>
                  <div className='leftTit' style={{ marginBottom: 10}}>{t(`outboundCall.survey`)}</div>
                </Col>
              </Row>
              <div className='question-content'><Spin spinning={isFetchingRemarkTemplate}><Row gutter={[16, 0]}>
                {questionContent?.map((item, index) => (
                  item.question_type === 'radio' ? (
                    <Col span={24} key={item.question_name} className='inline-label'>
                      <Form.Item name={item.question_name} colon={true} label={
                        <Text
                          style={{width: 100}}
                          ellipsis={{
                            tooltip: item.question_name,
                          }}
                        >
                          { item.question_name }
                        </Text>
                      }>
                        <Radio.Group onChange={(e) => this.onChangeQuestionContent(e.target.value, index)}>
                          {item.answer_item.map(answer => (
                            <Radio value={answer} key={answer}>{answer}</Radio>
                          ))}
                        </Radio.Group>
                      </Form.Item>
                    </Col>
                  ) : item.question_type === 'select' ? (
                    <Col span={24} key={item.question_name} className='inline-label'>
                      <Form.Item name={item.question_name} colon={true} label={
                        <Text
                          style={{width: 100}}
                          ellipsis={{
                            tooltip: item.question_name,
                          }}
                        >
                          { item.question_name }
                        </Text>
                      }>
                        <Checkbox.Group onChange={(e) => this.onChangeQuestionContent(e, index)}>
                          {item.answer_item.map(answer => (
                            <Checkbox value={answer} key={answer}>{answer}</Checkbox>
                          ))}
                        </Checkbox.Group>
                      </Form.Item>
                    </Col>
                  ) : (
                    <Col span={24} key={item.question_name} className='inline-label'>
                      <Form.Item name={item.question_name} colon={true} label={
                        <Text
                          style={{width: 100}}
                          ellipsis={{
                            tooltip: item.question_name,
                          }}
                        >
                          { item.question_name }
                        </Text>
                      } onChange={(e) => this.onChangeQuestionContent(e.target.value, index)}>
                        <Input allowClear />
                      </Form.Item>
                    </Col>
                  )
                ))}
              </Row></Spin></div>
            </>}
            {historyList?.length > 0 ? <>
              <Divider />
              <div className='leftTit' style={{ marginBottom: 10}}>{t(`outboundCall.historySurvey`)}</div>
              <div className='call-history'>
                {historyList.map((item, i) => (
                  <Descriptions
                    bordered
                    title={<>
                      <div style={{
                        width: '20px',
                        height: '20px',
                        lineHeight: '18px',
                        textAlign: 'center',
                        background: '#979797',
                        borderRadius: '4px',
                        display: 'inline-block',
                        marginRight: '8px'
                      }}>
                        <HistoryOutlined  style={{fontSize: '12px', color: '#ffffff'}} />
                      </div>
                      {item?.createUser}
                    </>}
                    extra={<span style={{color: '#bfbfbf'}}>{item?.createTime}</span>}
                    key={i}
                    column={2}
                    size='small'
                  >
                    {item.questionContent.map((a, ii) => (
                      <Descriptions.Item key={ii} label={
                        <Text
                          style={{width: 100}}
                          ellipsis={{
                            tooltip: a.question_name,
                          }}
                        >
                          { a.question_name }
                        </Text>
                      }>
                        <Text
                          style={{width: 100}}
                          ellipsis={{
                            tooltip: Array.isArray(toJS(a.data)) ? a.data?.join(', ') : a.data
                          }}
                        >
                          { Array.isArray(toJS(a.data)) ? a.data?.join(', ') : a.data }
                        </Text>
                      </Descriptions.Item>
                    ))}
                  </Descriptions>
                ))}
              </div>
            </> : null}
          </Form>
        </Modal>
      </>
    )
  }
}

export default withTranslation()(FormModal)
